import {useLoggedInUser} from '@/api/users/useLoggedInUser';
import {LanguageToggle} from '@/componentLibrary/components/Dropdowns/LanguageToggle';
import {LogoWithText} from '@/componentLibrary/components/Logo/LogoWithText';
import {Icon} from '@/componentLibrary/components/icons/Icon';
import {Icons} from '@/componentLibrary/components/icons/constants';
import {H2, P1} from '@/componentLibrary/components/typography';
import {ColorFgSuccess} from '@/componentLibrary/tokens/variables';
import {useExtractPhraseConstants} from '@/hooks/useExtractPhraseConstants';
import {useSuccessPageLogic} from './logic';
import messages from './messages';
import {Button, Content, ContentWrapper, HeaderWrapper, Title, Wrapper} from './styled';
import {Props} from './types';

export function SuccessPage({organizationId, collectedFromLinkedin}: Props) {
    const phrases = useExtractPhraseConstants(messages);
    const goToJobApplications = useSuccessPageLogic(organizationId);
    const {user} = useLoggedInUser();

    return (
        <Wrapper>
            <HeaderWrapper>
                <LogoWithText />
                <LanguageToggle userId={user?.id} fullWidth={false} />
            </HeaderWrapper>
            <ContentWrapper>
                <Content>
                    <Title>
                        <Icon icon={Icons.CHECK_CIRCLE_FILL} fill={ColorFgSuccess} size={40} />
                        {collectedFromLinkedin && <H2>{phrases.linkedInDataTitle}</H2>}
                    </Title>
                    <P1>{phrases.description}</P1>
                    <Button style={{width: 'fit-content'}} onClick={goToJobApplications}>
                        {phrases.continueToTests}
                    </Button>
                </Content>
            </ContentWrapper>
        </Wrapper>
    );
}
